export default __webpack_public_path__ + "static/media/typicons.6df05c03.woff";